import React, { useEffect, useState } from 'react';
import boardsService from '../../services/boards.service';
import { getBoardInfo, setBoardInfo } from '../../Utils/authentication-access';
import './SidebarItem.css';
import PubSub from 'pubsub-js';
import { EVENTS } from '../../constants/events';

const BoardFilterInfo = ({ boardInfo, spacesInfo }) => {

  console.log("boardInfo")
  let canvasInfo = 0;
  let boardData = getBoardInfo();

  const openBoard = async (child) => {
    await setBoardInfoData(child.meta.classId);
    let boardData = getBoardInfo();

    window.location.reload();
    //TODO commented for texting
    // PubSub.publish(EVENTS.BOARD_CHANGED, {});
    // setSpaceId(child.parentId);
    // spacesInfo.map((space) => (space.id == child.parentId ? setSpaceName(space.name) : ''));
  };

  const setBoardInfoData = async (classID) => {
    const response = await boardsService.getBoards(classID);
    const classInfo = response.data.data;
    const { email, hardwareId, name, flowId, classId } = classInfo;
    canvasInfo = {
      email,
      hardwareId,
      name,
      flowId,
      classId,
    };
    setBoardInfo(canvasInfo);
  };

  return (
    <>
      {boardInfo.map((item) => (
        <div
          style={{ cursor: 'pointer' }}
          className={
            boardData.classId == item.meta.classId
              ? 'enableBoardFilter active'
              : 'enableBoardFilter'
          }
          onClick={() => {
            openBoard(item);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div className="boardCircleContainer" style={{ background: `${item.color}` }}></div>
            <div>
              <div>{item.name}</div>

              {spacesInfo.map((space) =>
                space.id == item.parentId ? (
                  <div className="ParentSpace"> in {space.name} </div>
                ) : (
                  ''
                ),
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BoardFilterInfo;
